import styled from "@emotion/styled";
import { HEADER_TEXT_COLOR, LIGHT_COLOR } from "../../styles/color";

export interface IButtonStyledBackground {
  styleVariant?: "dark" | "light" | "outline" | "outline-dark";
  width?: string;
  height?: string;
  padding?: string;
  type?: string;
  radius?: string;
}

export const ButtonStyled = styled.button<IButtonStyledBackground>`
  width: ${({ width }) => width ?? "200px"};
  height: ${({ height }) => height ?? "40px"};
  justify-content: center;
  padding: ${({ padding }) => padding ?? "auto"};
  align-items: center;
  border-radius: ${({ radius }) => radius ?? "30px"};
  gap: 5px;
  background: ${({ styleVariant }) => {
    switch (styleVariant) {
      case "dark":
        return HEADER_TEXT_COLOR;
      case "light":
        return LIGHT_COLOR;
      default:
        return "none";
    }
  }};
  cursor: pointer;
  display: flex;
  color: ${({ styleVariant }) => {
    switch (styleVariant) {
      case "dark":
        return LIGHT_COLOR;
      case "light":
        return HEADER_TEXT_COLOR;
      case "outline-dark":
        return LIGHT_COLOR;
      default:
        return HEADER_TEXT_COLOR;
    }
  }};
  border: ${({ styleVariant }) => {
    switch (styleVariant) {
      case "outline":
        return HEADER_TEXT_COLOR + " solid  2px";
      case "outline-dark":
        return LIGHT_COLOR + " solid  2px";
      default:
        return "none";
    }
  }};
  font-family: "Verdana", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  white-space: nowrap;
`;
